import { render, staticRenderFns } from "./BioModal.vue?vue&type=template&id=5baec848&scoped=true&"
import script from "./BioModal.vue?vue&type=script&lang=ts&"
export * from "./BioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../imicsspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baec848",
  null
  
)

export default component.exports